import { render, staticRenderFns } from "./CuponesDescuentoComponent.vue?vue&type=template&id=417fceb6&scoped=true"
import script from "./CuponesDescuentoComponent.vue?vue&type=script&lang=js"
export * from "./CuponesDescuentoComponent.vue?vue&type=script&lang=js"
import style0 from "./CuponesDescuentoComponent.vue?vue&type=style&index=0&id=417fceb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417fceb6",
  null
  
)

export default component.exports